import $ from "jquery";
import "slick-carousel";
import "masonry-layout";
import "imagesloaded";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// 思考メモ - 一覧表示時の「もっと見る」
$(function () {
  $('.js-show-list-note-content').on('click', function (e) {
    e.preventDefault();
    $(this).parents('.js-list-note-excerpt').addClass('d-none');
    $(this).parents('.js-list-note').find('.js-list-note-content').removeClass('d-none');
  })
});

// slick.js
$(".slick").slick({
  centerMode: true,
  centerPadding: "25vw",
  slidesToShow: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  dots: true,
  variableWidth: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: "40px",
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: "40px",
        slidesToShow: 1,
      },
    },
  ],
});

// Popular posts - Select range
$(".js-btn-popular-posts").on("click", function () {
  const target = $(this).data("target");
  $(".js-popular-posts-wrapper > div").addClass("d-none");
  $("." + target).removeClass("d-none");
});

// Show and hide global header.
$(function () {
  const class_name = "is-scroll-down";
  var pos = 0;
  var before_pos = 0;
  var scrolled_pos = 0;
  var is_scroll_down = false;
  var offset_top = 300;
  var offset_scroll_up = 500;
  $(window).on("scroll", function () {
    pos = $(this).scrollTop();
    if (pos > before_pos) {
      is_scroll_down = true;
      scrolled_pos = pos;
    } else {
      is_scroll_down = false;
    }
    before_pos = pos;
    if (pos <= 0) {
      $("body").removeClass(class_name);
    } else if (pos > offset_top && is_scroll_down) {
      $("body").addClass(class_name);
    }
    if (scrolled_pos - pos > offset_scroll_up) {
      $("body").removeClass(class_name);
    }
  });
});

// For small screen devises - Show global nav.
$(".js-menu-toggle").on("click", function (e) {
  e.preventDefault();
  $("body").toggleClass("is-menu-open");
});

// Get menu height, set negative margin.
$(function () {
  setNegativeMarginToGlobalNav();
});
$(window).on("resize", () => {
  setNegativeMarginToGlobalNav();
});
function setNegativeMarginToGlobalNav() {
  const $primary_menu = $("#mobile-primary-menu");
  const $global_nav = $("#mobile-primary-menu > ul");
  const nav_height = $global_nav.outerHeight();
  $primary_menu.css({
    "margin-top": "-" + nav_height + "px",
  });
}

// For small screen devises - Show search field.
$(".js-search-toggle").on("click", function (e) {
  e.preventDefault();
  $("body").toggleClass("is-search-open");
});

// 倉貫書房 - rickey2 次回予告ページ
if (document.querySelector('.page-template-shobo-rickey2')) {
  // タイトルのアニメーション
  {
    gsap.registerPlugin(ScrollTrigger);
    const heading = document.querySelector('.js-r2-hero-unit-heading');
    if (heading) {

      const characterLength = heading.textContent.replace(/\s+/g, '').split('').length;
      const speed = 50;

      const headings = document.querySelectorAll('.js-r2-hero-unit-heading div');

      headings.forEach((heading, index) => {
        const characters = heading.textContent.replace(/\s+/g, '').split('');
        let delay = 1000;
        if (index == 1) {
          delay += speed * characters.length + 200;
        }
        heading.textContent = '';
        heading.classList.remove('d-none')
        characters.forEach((character, i) => {
          setTimeout(() => {
            const element = document.createElement('span');
            element.classList.add('d-inline-block', 'bg-black');
            element.textContent = character;
            heading.appendChild(element);
          }, speed * i + delay);
        });
      });

      const mask = document.querySelector('.js-r2-hero-unit-mask');
      const scroll = document.querySelector('.js-r2-hero-unit-scroll');
      const delay = characterLength * speed + 1400;
      setTimeout(() => {
        mask.style.clipPath = "circle(100%)";
        scroll.style.animationName = 'r2-hero-unit-scroll-animation';
      }, delay);

      gsap.fromTo(
        mask,
        {
          scale: 1,
        },
        {
          scale: 2,
          scrollTrigger: {
            trigger: mask,
            start: "bottom 100%",
            end: "+=90%",
            scrub: true,
            toggleActions: "restart pause resume pause",
          },
        }
      );
    }
  }

  // イントロダクション文のアニメーション
  {
    gsap.from(
      '.js-r2-introduction',
      {
        opacity: 0,
        scale: 0.7,
        scrollTrigger: {
          trigger: '.js-r2-introduction',
          start: "bottom 125%",
          end: "+=50%",
          scrub: true,
          // markers: true,
          toggleActions: "restart pause resume pause",
        },
      }
    );
  }

  // セリフのアニメーション
  {
    const elements = document.querySelectorAll('.js-r2-word');
    if (elements) {
      elements.forEach((element, i) => {

        let xValue = '100px';
        if (i % 2) {
          xValue = '-100px';
        }

        const clockwise = [1, 2, 5, 8];
        const counterclockwise = [4, 6, 11];
        let rotateValue = 0;
        if (clockwise.indexOf(i) >= 0) {
          rotateValue = 1;
        } else if (counterclockwise.indexOf(i) >= 0) {
          rotateValue = -1;
        }

        gsap.fromTo(
          element,
          {
            opacity: 0,
            x: xValue,
          },
          {
            opacity: 1,
            x: 0,
            rotate: rotateValue,
            ease: "power4.out",
            scrollTrigger: {
              trigger: element,
              start: "bottom 90%",
              end: "+=400px",
              // markers: true,
            }
          }
        )
      })
    }
  }

  // ニュースレターのアニメーション
  {
    gsap.registerPlugin(ScrollTrigger);
    gsap.from('.js-r2-subscribe',
      {
        opacity: 0,
        scale: 0.7,
        scrollTrigger: {
          trigger: '.js-r2-subscribe',
          toggleActions: "restart pause resume pause",
        },
      }
    );

    // 吹き出しの位置を調整
    const baloon = document.querySelector('.js-r2-subscribe-baloon');
    baloon.style.marginTop = "calc( -" + baloon.offsetHeight + "px + 2rem)";
  }

  // 感想リンクのアニメーション
  {
    gsap.registerPlugin(ScrollTrigger);
    gsap.to('.js-r2-link-reaction-wrapper',
      {
        opacity: 1,
        scrollTrigger: {
          trigger: '.js-r2-main-content',
          start: 'top 95%',
          toggleActions: 'play none none reverse',
        }
      }
    )
  }
}
